import React from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import CONTENT from "src/library/content.json";

type InfoProps = {
  section: string;
  data: string;
  isMobile?: boolean;
  remote?: boolean;
};

const InfoSection = (props: InfoProps) => {
  const { section, data } = props;
  return (
    <Grid item container justifyContent="space-between" xs={12}>
      <Grid item xs={4} sm={4}>
        <Typography
          variant="h6"
          component="p"
          fontWeight="fontWeightBold"
          textAlign="right"
          color="secondary.light"
          sx={{ py: 1, pr: 2, height: "100%", float: "right" }}
        >
          {section}
          {":"}
        </Typography>
      </Grid>
      <Grid item xs={8} sm={8}>
        <Typography
          variant="body1"
          component="p"
          fontWeight="fontWeightBold"
          textAlign="left"
          color="text"
          sx={{ py: 1, pl: 2, height: "100%", display: "flex", alignItems: "center" }}
        >
          {data}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default function ConnectathonInfo() {
  const {
    pageTitles: { date, time, location, attendants },
  } = CONTENT;

  return (
    <Container maxWidth="md">
      <Grid container direction="column" sx={{ pt: 2 }}>
        <InfoSection section="Date" data={date} />
        <InfoSection section="Time" data={time} />
        <InfoSection section="Event Location" data={location} />
        <InfoSection section="Attendants" data={attendants} />
        <InfoSection section="Special Guest Speaker" data={"Stephanie 'Hex' Bendixsen"} />
      </Grid>
    </Container>
  );
}
